import React from 'react';
import styles from './choice.module.css';

/**
 * A row of cards choosing one option, each an icon over its name (the border style). An option's `ariaLabel` can
 * name it more fully for screen readers; `disabled` with a `title` says why it cannot be picked.
 */
export const OptionCards = ({ label, options, value, onChange }) => (
    <div className={styles.optionCards} role="radiogroup" aria-label={label}>
        {options.map((option) => (
            <button
                key={option.value}
                type="button"
                role="radio"
                aria-checked={option.value === value}
                aria-label={option.ariaLabel}
                disabled={option.disabled}
                title={option.title}
                className={`${styles.optionCard} ${option.value === value ? styles.optionCardOn : ''}`.trim()}
                onClick={() => onChange(option.value)}
            >
                <span className={styles.optionCardIcon} aria-hidden="true">{option.icon}</span>
                <span className={styles.optionCardLabel}>{option.label}</span>
            </button>
        ))}
    </div>
);
